import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { verifyEmail } from "../lib/authApi";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState<"pending" | "ok" | "err">("pending");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("err");
      setMessage("Missing verification token.");
      return;
    }
    verifyEmail(token).then(({ res, data }) => {
      if (res.ok) {
        setStatus("ok");
        setMessage(data.message || "Email verified. You can sign in now.");
      } else {
        setStatus("err");
        setMessage(data.message || "Verification failed or link expired.");
      }
    });
  }, [token]);

  return (
    <div className="auth-bg flex min-h-full items-center justify-center px-4 py-10">
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
        <h1 className="text-lg font-semibold text-text-primary">Email verification</h1>
        {status === "pending" && <p className="mt-3 text-text-secondary">Verifying…</p>}
        {status !== "pending" && (
          <p
            className={`mt-3 text-sm ${status === "ok" ? "text-status-ok" : "text-status-error"}`}
          >
            {message}
          </p>
        )}
        <Link to="/login" className="mt-6 inline-block text-sm text-accent hover:underline">
          Go to sign in
        </Link>
      </div>
    </div>
  );
}
